module.exports = __webpack_public_path__ + "img/1.d3b66892.png";